import { ExperiencesService } from './../../../experiences/experiences.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { Component, OnInit, ViewChild, OnChanges } from '@angular/core';
import {
  DVFormGroup,
  DVFormControl,
  DVFormArray
} from 'src/app/shared/helpers/dynamic-validators/dynamic-validator';
import { Validators } from '@angular/forms';
import { SnotifyService } from 'ng-snotify';
import { QuillEditorComponent } from 'ngx-quill';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import { FileHolder } from 'angular2-image-upload';
import { BlogsService } from '../blogs.service';

@Component({
  selector: 'app-blog',
  templateUrl: './blog.component.html',
  styleUrls: ['./blog.component.css']
})
export class BlogComponent implements OnInit {
  articleForm: DVFormGroup;
  isAddState = true;
  stateName: string;
  file: string;
  blogPictures = [];
  @ViewChild('editor', {
    static: true
  })
  editor: QuillEditorComponent;
  multiSelectSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'value',
    textField: 'display',
    allowSearchFilter: false,
  };
  experiences: any[];

  constructor(
    private blogsApi: BlogsService,
    private experiencesService: ExperiencesService,
    private notifier: SnotifyService,
    private router: Router,
    public route: ActivatedRoute
  ) {
    this.blogsApi.getArticles().subscribe(Response => {
      // console.log(Response)
    });
    this.articleForm = new DVFormGroup({
      slug: new DVFormControl(null, {
        'slug  is required': Validators.required
      }),
      title: new DVFormControl(null, {
        'title  is required': Validators.required
      }),
      metaTitle: new DVFormControl(null, {
        'Meta Title is required': Validators.required
      }),
      subtitle: new DVFormControl(null, {
        'Subtitle is required': Validators.required
      }),
      description: new DVFormControl(null, {
        'Description is required': Validators.required
      }),
      metaDescription: new DVFormControl(null, {
        'Meta Description is required': Validators.required
      }),
      metaKeywords: new DVFormControl(null, {
        'Meta Keywords is required': Validators.required
      }),

      coverPhoto: new DVFormControl(null, {
        'Cover Photo is required': Validators.required
      }),

      body: new DVFormControl(),
      tags: new DVFormControl(null, {
        'Tags is required': Validators.required
      }),
      experiences: new DVFormControl([]),
      items: new DVFormArray(
        [],
        [
          {
            name: 'id',
            type: 'CONTROL',
            default: null,
          },
          {
            name: 'body',
            type: 'CONTROL',
            default: null,
          },
          {
            name: 'image',
            type: 'CONTROL',
            default: null,
          },
          {
            name: 'position',
            type: 'CONTROL',
            default: null,
          },
          {
            name: 'order',
            type: 'CONTROL',
            default: null,
          }
        ],
        0,
        {
          'Article Items': Validators.required
        }
      ),

    });
  }

  ngOnInit() {

    this.experiencesService.getAllExperience().subscribe(
      res => {
        this.experiences = (res.data.experiences as []).map((e: any) => {
          return {
            value: e.id,
            display: e.name
          };
        });
      }
    );

    if (this.route.snapshot.params[`id`]) {
      this.isAddState = false;
      this.blogsApi
        .getArticleByID(this.route.snapshot.params[`id`])
        .subscribe(Response => {
          this.articleForm.controls[`slug`].setValue(
            Response[`data`].article.slug
          );
          this.articleForm.controls[`title`].setValue(
            Response[`data`].article.title
          );
          this.articleForm.controls[`subtitle`].setValue(
            Response[`data`].article.subtitle
          );
          this.articleForm.controls[`description`].setValue(
            Response[`data`].article.description
          );
          this.articleForm.controls[`metaTitle`].setValue(
            Response[`data`].article.metaTitle
          );
          this.articleForm.controls[`metaDescription`].setValue(
            Response[`data`].article.metaDescription
          );
          this.articleForm.controls[`metaKeywords`].setValue(
            Response[`data`].article.metaKeywords
          );
          this.articleForm.controls[`tags`].setValue(
            Response[`data`].article.Tags
          );
          console.log('pwwwwwwwwwwww', Response[`data`].article);

          // this.articleForm.controls[`items`].setValue(
          //   Response[`data`].article.items
          // );
          this.articleForm.patchValue(Response[`data`].article);

          this.articleForm.controls[`experiences`].setValue(
            Response[`data`].article.Experiences.map((e: any) => {
              return {
                value: e.id,
                display: e.name
              };
            })
          );
          this.articleForm.controls.coverPhoto.setValue(
            Response.data.article.coverPhoto
          );
          this.blogPictures = [Response[`data`].article.coverPhoto];
          // this.articleForm.controls.body.setValue(Response.data.article.body);

        });
    } else {
      this.isAddState = true;
    }
    // this.articleForm.controls.body.valueChanges
    //   .pipe(debounceTime(400), distinctUntilChanged())
    //   .subscribe(data => {
    //     // tslint:disable-next-line:no-console
    //     // console.log('native fromControl value changes with debounce', data)
    //   });

    // this.editor.onContentChanged
    //   .pipe(debounceTime(400), distinctUntilChanged())
    //   .subscribe(data => {
    //     // tslint:disable-next-line:no-console
    //     // console.log('view child + directly subscription', data)
    //   });
  }

  fileUploaded(event) {
    // console.log(event)
    this.articleForm.controls.coverPhoto.reset();

    this.articleForm.controls.coverPhoto.setValue(event[`name`]);
  }

  SubmitForm() {
    if (this.articleForm.valid) {
      const formValue = this.getCleanValue();
      formValue.body = "test";
      console.log('sssssssssssssssss', formValue);
      this.blogsApi.addArticle(formValue).subscribe(
        Response => {
          this.notifier.success('Article Added Successfully');
          this.articleForm.reset();
          this.router.navigateByUrl('/settings/blogs/list');
        },
        error => {
          this.notifier.error(error.error.userMessage);
        }
      );
    } else {
      this.articleForm.forceShowErrors();
    }
  }

  EditForm() {
    if (this.articleForm.valid) {
      const formValue = this.getCleanValue();
      formValue.body = "test";
      console.log('sssssss', formValue);
      this.blogsApi
        .editArticle(formValue, this.route.snapshot.params[`id`])
        .subscribe(
          Response => {
            // console.log(Response)
            this.notifier.success('Article Edited Successfully');
            this.articleForm.reset();
            this.router.navigateByUrl('/settings/blogs/list');
          },
          error => {
            this.notifier.error(error.error.userMessage);
          }
        );
    } else {
      this.articleForm.forceShowErrors();
    }
  }

  getCleanValue() {
    return {
      ...this.articleForm.value,
      tags: this.articleForm.controls.tags.value.map(a => a.id),
      experiences: this.articleForm.controls.experiences.value.map(a => a.value),
    };
  }

  cancel() {
    this.isAddState = true;
    this.articleForm.reset();
    this.router.navigateByUrl('/settings/blogs/list');
  }
  openDialog() {
    document.getElementById('fileButton').click();
  }
  imageUploaded(holder: FileHolder) {
    if (holder.serverResponse.status === 200) {
      const imageBody = holder.serverResponse.response.body;
      delete imageBody.message;
      this.addImage(imageBody);
    }
  }
  private addImage(src) {
    const control = <DVFormControl> this.articleForm.controls[`coverPhoto`];
    const value: string = control.value || '';
    control.setValue(src.data.filePath);
  }

  imageRemoved(holder: FileHolder) {
  }
}
